import { AlertCircle } from 'lucide-react'
import type { FC } from 'react'

import './index.scss'

export interface InlineErrorProps {
  message: string
  className?: string
  /** For an input's `aria-describedby`. */
  id?: string
}

export const InlineError: FC<InlineErrorProps> = ({ message, className = '', id }) => (
  <div id={id} className={`inline-error ${className}`.trim()} role="alert">
    <AlertCircle className="inline-error__icon" size={20} strokeWidth={2} aria-hidden="true" />
    <span className="inline-error__text">{message}</span>
  </div>
)
